import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist/index.js';
import * as customersAPI from '@debbie/cortex/dist/api/customers.js';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import Button from '../Button.js';
import ButtonGroup from '../ButtonGroup.js';
import Input from '../Input.js';
import CreateUserOnCustomer, { getNewUser } from './CreateUserOnCustomer.js';
import CustomerPreview from './CustomerPreview.js';
let tid = null;
const CreateCustomer = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const tenantId = useSelector(selectTenantId);
    const [isCompany, setIsCompany] = useState(false);
    const [referenceId, setReferenceId] = useState(null);
    const [users, setUsers] = useState([]);
    const [existingCustomer, setExistingCustomer] = useState(null);
    const [customersReferenceIdMap, setCustomersReferenceIdMap] = useState({});
    useEffect(() => {
        if (!tenant && tenantId) {
            c.tenants.get(tenantId);
        }
    }, [tenantId]);
    useEffect(() => {
        if (tenant) {
            setUsers([getNewUser(tenant, true)]);
        }
    }, [tenant]);
    const onChange = (e) => {
        props.onChange(e);
    };
    const checkForExistingCustomer = async () => {
        if (props.creditorId) {
            try {
                const ref = referenceId;
                if (ref) {
                    const _existingCustomer = await customersAPI.getByReferenceId(props.creditorId, ref);
                    setCustomersReferenceIdMap({
                        ...customersReferenceIdMap,
                        [ref]: _existingCustomer,
                    });
                }
            }
            catch (error) {
                console.log(error);
            }
        }
    };
    useEffect(() => {
        const existingCustomer = referenceId && customersReferenceIdMap[referenceId];
        if (existingCustomer) {
            setExistingCustomer(existingCustomer);
            props.onChangeExistingCustomer(existingCustomer);
        }
        else {
            setExistingCustomer(null);
            props.onChangeExistingCustomer(null);
        }
    }, [customersReferenceIdMap, referenceId]);
    useEffect(() => {
        if (referenceId && props.creditorId) {
            if (tid)
                clearTimeout(tid);
            tid = setTimeout(() => checkForExistingCustomer(), 150);
        }
        if (!referenceId && existingCustomer) {
            setExistingCustomer(null);
            props.onChangeExistingCustomer(null);
        }
    }, [referenceId, props.creditorId]);
    return (React.createElement("div", null,
        React.createElement(Input, { placeholder: lang.customers.customerReferenceId, value: referenceId || '', onChange: (e) => {
                const val = e.target.value;
                setReferenceId(val);
                onChange({
                    users,
                    referenceId: val || null,
                    isCompany,
                });
            } }),
        existingCustomer ? (React.createElement("div", null,
            React.createElement("h3", null, lang.customers.existingCustomer),
            React.createElement(CustomerPreview, { customerId: existingCustomer.customerId }))) : (React.createElement(React.Fragment, null,
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { size: "mini", onClick: () => {
                        setIsCompany(false);
                        onChange({
                            users,
                            referenceId,
                            isCompany: false,
                        });
                    }, theme: isCompany ? 'secondary' : undefined }, lang.customers.private),
                React.createElement(Button, { size: "mini", onClick: () => {
                        setIsCompany(true);
                        onChange({
                            users,
                            referenceId,
                            isCompany: true,
                        });
                    }, theme: !isCompany ? 'secondary' : undefined }, lang.customers.company)),
            React.createElement("div", { style: { marginTop: '10px' } }, users.map((user, i) => (React.createElement(CreateUserOnCustomer, { key: i, user: user, onChange: (c) => {
                    const _users = users.map((u, index) => {
                        if (index === i) {
                            return {
                                ...u,
                                ...c,
                            };
                        }
                        else {
                            // Only one active contact person at a time
                            if (c.contact) {
                                return { ...u, contact: false };
                            }
                            return u;
                        }
                    });
                    setUsers(_users);
                    onChange({
                        users: _users,
                        referenceId,
                        isCompany,
                    });
                }, onDetailsChange: (c) => {
                    const _users = users.map((u, index) => {
                        if (index === i) {
                            return {
                                ...u,
                                details: {
                                    ...u.details,
                                    ...c,
                                },
                            };
                        }
                        else {
                            return u;
                        }
                    });
                    setUsers(_users);
                    onChange({
                        users: _users,
                        referenceId,
                        isCompany,
                    });
                }, onDelete: () => {
                    const _users = users.filter((_, index) => index !== i);
                    setUsers(_users);
                    onChange({
                        users: _users,
                        referenceId,
                        isCompany,
                    });
                }, isCompany: isCompany })))),
            React.createElement(Button, { onClick: () => {
                    if (tenant) {
                        const _users = users.concat(getNewUser(tenant, false));
                        setUsers(_users);
                        onChange({
                            users: _users,
                            referenceId,
                            isCompany,
                        });
                    }
                }, size: "mini", theme: "secondary" }, lang.customers.addParty)))));
};
export default CreateCustomer;
//# sourceMappingURL=CreateCustomer.js.map